<mat-form-field floatLabel="auto" appearance="outline" class="w-100 bdg-date-field">
  <mat-label>
    {{ label }}
  </mat-label>
  <input
    matInput
    [matDatepicker]="datePicker"
    [formControl]="control"
    autocomplete="off"
    placeholder="aaaa"
    [errorStateMatcher]="matcher"
    readonly="true"
    (click)="onPickerClicked()"
    [maxLength]="4"
  />
  <mat-datepicker-toggle [class.mat-error]="error()" matSuffix [for]="datePicker"></mat-datepicker-toggle>
  <mat-datepicker
    #datePicker
    startView="multi-year"
    (yearSelected)="chosenYearHandler($event, datePicker)"
    panelClass="example-month-picker"
  >
  </mat-datepicker>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="error()">{{ error() }}</mat-error>
</mat-form-field>
